// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__1yKL2","header":"styles_header__2dw_6"};